package com.devi3east.bashbuddy.features.ticketing

class WebTicketingCapability : TicketingCapability {
    override fun canPurchaseTickets() = true
    override fun canViewOwnedTickets() = true
}